import { IAppConfig } from './types';

function loadStaticModules(appConfig: IAppConfig) {
  require('/Users/pankuiyan/Desktop/formProject/recept-pc/node_modules/build-plugin-ice-request/lib/runtime.js').default(
    { appConfig }
  );
}

export default loadStaticModules;
